import React, { Component } from 'react';
import ProjectsEditLayout from '../../templates/projects';
import ProjectEmployeesEditForm from '../../elements/projects/employees';
import Loading from "../../elements/loading";

class ProjectEmployeesEdit extends Component {
	render (){
		const {projects} = this.props;
		return (
			projects.isFetching ? <Loading message="Cargando..." />:<ProjectEmployeesEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchStatus(1);
		this.props.fetchProjectEmployeesEdit(this.props.match.params.id);
	}
}

export default ProjectsEditLayout(ProjectEmployeesEdit, {subnav: 4});



// WEBPACK FOOTER //
// ./src/layouts/projects/employees.jsx